import {
  Col,
  Form,
  Input,
  Row,
  DatePicker,
  Select,
  Table,
  Checkbox,
  Space,
  Image,
} from 'antd';
import * as XLSX from 'xlsx';
import type { FormInstance } from 'antd';
import Button from 'components/Button';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import CartApi from 'apis/CartApi';
import { useEffect, useState } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { useUser } from 'contexts/User';
import { useMutation, useQuery } from 'react-query';
import PortfolioApi from 'apis/PortfolioApi';
import moment from 'moment';
import PofTypeApi from 'apis/PofTypeApi';
import DeclareCartPage from './DeclareCart';
import { ICartPost } from 'interface/cart.interface';
import { PRODUCT_POF_STATUS, PRODUCT_STATUS } from 'constants/productStatus';
import { IProduct } from 'interface/product.interface';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import { ColumnsType } from 'antd/es/table';
import { DownloadOutlined } from '@ant-design/icons';
import { openNotificationWithIcon } from 'utils/notification';
import { HocChangePagination } from 'utils/HocChangePagination';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
interface Iparam {
  id?: string;
}

export default function DeclareCartReviewInfo(): JSX.Element {
  const { id } = useParams<Iparam>();
  const queryParam = useQueryParam();
  const history = useHistory();
  const { user } = useUser();
  const { TextArea } = Input;
  const { Option } = Select;
  const [form] = Form.useForm();
  const dateFormat = 'DD/MM/YYYY';
  const location = useLocation<{
    edit?: boolean;
    listPofCode: string[];
    listProductSelected: IProduct[];
  }>();
  const listProductSelected: IProduct[] = location.state?.listProductSelected;
  const listPofCode: string[] = location.state?.listPofCode;
  const setStep = useCategoryManagementStore((state) => state.setStep);

  // const { data: lstPofType } = useQuery(['getAll'], () =>
  //   PofTypeApi.getCartType()
  // );
  // const { data: porfolioDetail, isLoading } = useQuery(
  //   ['get'],
  //   () => PortfolioApi.getDetail(id || ''),
  //   { enabled: !!id }
  // );

  useEffect(() => {
    setStep(2);
  }, []);

  const validateMessages = {
    required: '${label} không được để trống!',
  };

  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const columns: ColumnsType<IProduct> = [
    {
      title: 'STT',
      dataIndex: 'ma_mau',
      width: 80,
      render: (record) => {
        const index =
          listProductSelected.findIndex((item) => item.ma_mau === record) + 1;
        return index;
      },
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'ma_mau',
      width: 177,
    },
    {
      title: 'Hình ảnh',
      dataIndex: 'image_default',
      render: (record: any) => {
        return (
          <Image
            className="border border-solid border-neutral-90 rounded-lg"
            src={record}
            width={50}
            height={50}
          />
        );
      },
      width: 100,
    },
    {
      title: 'Tên mẫu',
      dataIndex: 'ten_mau',
      width: 261,
    },
    {
      title: 'Ni',
      dataIndex: 'ni_sanpham',
      width: 261,
    },
    {
      title: 'Bộ phận phát triển',
      dataIndex: 'nhan_hang',
      width: 261,
    },
    {
      title: 'Ngành hàng',
      width: 115,
      dataIndex: 'nganh_hang',
    },
    {
      title: 'Dòng hàng',
      dataIndex: 'dong_hang',
      width: 148,
    },
    {
      title: 'X-man',
      dataIndex: 'xman',
      width: 148,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chung_loai',
      width: 148,
    },
    {
      title: 'Kết luận đánh giá 3 tiêu chí',
      // dataIndex: 'chung_loai',
      width: 148,
    },
    {
      title: 'Doanh thu 6 tháng gần nhất',
      // dataIndex: 'chung_loai',
      width: 148,
      align: 'right',
    },
    {
      title: 'Tổng SL tồn hiện tại',
      dataIndex: 'tongsl_ton',
      width: 112,
      align: 'right',
    },
    {
      title: 'Tổng giá trị tồn hiện tại',
      dataIndex: 'tong_giatri',
      width: 112,
      align: 'right',
    },
    {
      title: 'Giá trung bình',
      dataIndex: 'gia_tb',
      width: 112,
      align: 'right',
    },
    {
      title: 'Chi nhánh',
      dataIndex: 'chi_nhanh',
      width: 112,
    },
    {
      title: 'Cửa hàng',
      dataIndex: 'cua_hang',
      width: 112,
    },
    {
      title: 'Số lượng phân bổ',
      dataIndex: 'so_luong_phan_bo',
      width: 112,
    },
    {
      title: 'Vốn tồn phân bổ',
      dataIndex: 'von_ton_phan_bo',
      width: 112,
    },
    {
      title: 'Product code',
      dataIndex: 'pro_code',
      width: 112,
    },
    {
      title: 'Pof code',
      dataIndex: 'pof_code',
      width: 112,
    },
    {
      fixed: 'right',
      align: 'center',
      width: 0,
    },
  ];

  const { mutate: inserProductToCart, isLoading: isProductLoading } =
    useMutation(
      () =>
        CartApi.inserProductToCart({
          cart_info_id: id,
          list_pof_code: listPofCode,
          list_cart_product: listProductSelected,
        }),
      {
        onSuccess: (response: any) => {
          console.log(response);
          openNotificationWithIcon(
            'success',
            `${
              location.state?.edit
                ? 'Sửa giỏ hàng thành công'
                : 'Tạo giỏ hàng thành công'
            }`
          );
          history.push('/cart-list');
        },
        onError: (error: any) => {
          console.log(error);
          openNotificationWithIcon('error', error.message);
        },
      }
    );

  function generateExcel() {
    const data = [];

    // create title
    const headerRow = columns.map((column) => {
      if (column.dataIndex === 'isSelected') {
        return 'Đã chọn';
      } else {
        return column.title;
      }
    });
    data.push(headerRow);

    // create data
    listProductSelected.forEach((product) => {
      const rowData = columns.map((column) => {
        if (column.dataIndex === 'isSelected') {
          return true;
        }
        return product[column.dataIndex];
      });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `mau_san_pham.xlsx`);
  }

  return (
    <DeclareCartPage isLoading={isProductLoading}>
      <Content>
        <div className="text-xl font-bold mb-6">1. Khai báo giỏ hàng</div>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
          <Col className="" span={12}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                Người tạo
              </Col>
              <Col className="" span={12}>
                : {user?.fullName}
              </Col>
            </Row>
          </Col>
          <Col className="" span={12}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                Email
              </Col>
              <Col className="" span={12}>
                : {user?.email}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
          <Col className="" span={12}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                Khối phát hành
              </Col>
              <Col className="" span={12}>
                : {user?.division}
              </Col>
            </Row>
          </Col>
          <Col className="" span={12}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                Công ty phát hành
              </Col>
              <Col className="" span={12}>
                : {user?.organization}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="" span={3}>
            Đơn vị phát hành
          </Col>
          <Col className="" span={20}>
            : {user?.departmentName}
          </Col>
        </Row>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: '20px', marginTop: '20px' }}
        >
          <div className="font-bold">
            Danh sách sản phẩm thuộc giỏ hàng: {listProductSelected?.length}
          </div>
          <Button
            bgColor={'bg-white'}
            color={'text-primary-50'}
            border={'border-primary-50'}
            customClass="fix-border-radius"
            onClick={generateExcel}
          >
            <DownloadOutlined></DownloadOutlined>
            Tải file excel
          </Button>
        </Row>

        <Table
          rowKey={(record) => record.id}
          className="customTable"
          size="small"
          columns={columns}
          dataSource={listProductSelected || []}
          scroll={{ x: 970 }}
          pagination={{
            className: 'flex items-center',
            total: listProductSelected?.length,
          }}
        />
      </Content>

      <Row
        justify="end"
        align="middle"
        style={{ marginBottom: '20px', marginTop: '20px' }}
      >
        <Space size={16}>
          {/* <Button
            onClick={() => (window.location.href = '/category')}
            bgColor={'bg-white'}
            color={'text-primary-50'}
            border={'border-primary-50'}
            customClass="fix-border-radius"
          >
            Trở lại
          </Button> */}
          {/* <Button
            onClick={() => (window.location.href = '/category')}
            bgColor={'bg-white'}
            color={'text-primary-50'}
            border={'border-primary-50'}
            customClass="fix-border-radius"
          >
            Lưu nháp
          </Button> */}
          <Button
            onClick={() => {
              inserProductToCart();
            }}
          >
            {location.state?.edit ? 'Sửa giỏ hàng' : 'Tạo giỏ hàng'}
          </Button>
        </Space>
      </Row>
    </DeclareCartPage>
  );
}
